import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { DevPanel } from '@sennder/shell-utilities'

import { isLocalEnv } from '@/common/config'
import { getFederatedConfig } from '@/services/getFederatedConfig'
import { moduleConfiguration } from '@/modules-configuration'
import {
  type OrcasStoreData,
  getStateData,
  getStateFeatureFlags,
  setStoreFeatureFlags,
  setStoreData,
} from '@/store'

import router from '@/router'
import pkgJson from '../../package.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'DevPanel',
  setup(__props) {

const featureFlags = computed(getStateFeatureFlags)
const state = computed(getStateData)

const modules = new Map(
  moduleConfiguration.map((config) => {
    const fml = getFederatedConfig(config)
    return [fml.npmName, fml.devPort]
  })
)

const onToggleHotMode = async (npmName: string) => {
  // If this is the module we're currently rendering, let's reload the page to mount the new version
  if (router.currentRoute.value.meta.npmName === npmName) {
    const { fullPath } = router.currentRoute.value
    router.push({ path: '/reload' }).then(() => {
      requestAnimationFrame(() => {
        router.push({ path: fullPath })
      })
    })
  }
}

const setData = (state: object) => {
  setStoreData(state as OrcasStoreData)
}

const setFeatureFlag = (key: string, value: boolean) => {
  setStoreFeatureFlags({
    ...getStateFeatureFlags(),
    [key]: value,
  })
}

return (_ctx: any,_cache: any) => {
  return (_unref(isLocalEnv)())
    ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_unref(DevPanel), {
            "style-overrides": "",
            "module-configuration": {
        moduleConfiguration: _unref(moduleConfiguration),
      },
            "feature-flags": {
        updateFlag: setFeatureFlag,
        flags: featureFlags.value,
      },
            state: {
        state: state.value,
        updateState: setData,
      },
            overrides: {
        modules: _unref(modules),
        onToggleHotMode: onToggleHotMode,
      },
            "log-requests": "",
            "pkg-json": _unref(pkgJson)
          }, null, 8 /* PROPS */, ["module-configuration", "feature-flags", "state", "overrides", "pkg-json"])
        ]),
        _: 1 /* STABLE */
      }))
    : _createCommentVNode("v-if", true)
}
}

})